import {
  WEBHOOK_FIND_ALL,
  WEBHOOK_SET_INITIAL_STATE,
  WEBHOOK_VIEW
} from './webhookTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case WEBHOOK_SET_INITIAL_STATE:
      return initialState;
    case WEBHOOK_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case WEBHOOK_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
